import { Component, OnInit } from '@angular/core';
import { ModalService } from 'projects/mariano-max/src/app/core/app-shared/public-api';
import { MarianomGeneral } from '../../marianom-general.service';
import { EcommerceGenericoService } from 'projects/mariano-max/src/app/core/ecommerce-generico/public-api';

@Component({
  selector: 'modal-articulo',
  templateUrl: './modal-articulo.component.html',
  styleUrls: ['./modal-articulo.component.scss']
})

export class ModalArticuloComponent implements OnInit {

  constructor(private serv: MarianomGeneral, public genServ : EcommerceGenericoService, private modal: ModalService) {
    this.articuloOpened;
  }

  ngOnInit(): void {
    this.genServ.returnUsaBultos().subscribe(data => {
      this.usaBultos = (data || 'N').toString().trim();
    });

    this.genServ.returnUsaLista().subscribe(data => {
      this.usaLista = (data || 'N').toString().trim();
    });
  }

  get articulo() {
    this.articuloOpened = this.genServ.returnArtOpened();
    return this.articuloOpened;
  }

  permiteBultosArticulo(): boolean {
    if (!this.articulo) {
      return false;
    }

    if (this.articulo.getUnidadesPorBulto() <= 1) {
      return false;
    }

    if (this.usaBultos === 'S') {
      return true;
    }

    if (this.usaBultos === 'N') {
      return false;
    }

    if (this.usaBultos === 'L') {
      return this.usaLista === 'S';
    }

    return false;
  }

  sumaevent(numero: number) {
    if (numero > 0) {
      if (this.articulo.getCantidad() == 0) {
        if (!this.serv.isloged()) {
          this.serv.abrirModalLogin();
        }
        else {
          this.articulo.agregarCantidad(numero);
          this.serv.articuloAmostrar(this.articulo);
        }
      }
      else {
        if (this.articulo.getCantidadMaxima() > this.articulo.getCantidad() || numero < 0 || this.articulo.getCantidadMaxima() == 0 || this.articulo.getCantidadMaxima() > numero && numero !=1) {
          if (this.articulo.getCantidadMaxima() == 0 || this.articulo.getCantidadMaxima() > numero) {
            this.articulo.agregarCantidad(numero);
            this.serv.articuloAmostrar(this.articulo);
          }
          else {
            this.modal.open('modal-max-art');
          }
        }else {
          this.modal.open('modal-max-art');
        }
      }
    }
    else {

      if (this.articulo.getCantidadMaxima() > this.articulo.getCantidad() || numero < 0 || this.articulo.getCantidadMaxima() == 0 || this.articulo.getCantidadMaxima() > numero && numero != 1) {

        if ((this.articulo.getCantidad() + numero) >= 0 || this.articulo.getCantidadMaxima() > numero) {
          this.articulo.agregarCantidad(numero);
        } else {
          this.modal.open('modal-max-art');
        }

      } else {
        this.modal.open('modal-max-art');
      }

    }
    console.log('debug articulo', this.articulo);
    this.genServ.sincronizarCarritoFrontyBack();
    this.articulo.operacionesExtras();

  }

  sumaeventBultos(numero: number) {
    if (numero > 0) {

    if (!this.serv.isloged()) {
      this.serv.abrirModalLogin();
    }
    else {
      this.articulo.agregarBultos(numero);
      this.serv.articuloAmostrar(this.articulo);
    }

    } else {

    this.articulo.agregarBultos(numero);
    this.serv.articuloAmostrar(this.articulo);

    }

    this.genServ.sincronizarCarritoFrontyBack();
    this.articulo.operacionesExtras();
  }

  closeModal() {
    this.modal.closeAll();
    this.mostrarMasInfo = false;
  }

  toggleMasInfo() {
    this.mostrarMasInfo = !this.mostrarMasInfo;
  }

  get ocultarPrecios (){
    return this.genServ.isOcultarPrecio()
  }

  usaBultos: string = 'N';
  usaLista: string = 'N';
  articuloOpened: any;
  mostrarMasInfo: boolean = false;
}
